import { useNow, UseNowOptions } from '@vueuse/core';
import { computed, ref } from 'vue';

const serverOffsetMs = ref(0);

export function syncServerTime(response: Response) {
    const header = response.headers.get('Date');
    if (!header) return;

    const serverTime = Date.parse(header);
    if (Number.isNaN(serverTime)) return;

    serverOffsetMs.value = serverTime - Date.now();
}

export function useServerNow(options?: UseNowOptions<false>) {
    const clientNow = useNow(options);

    // Offset the wall clock rather than counting monotonic time from the last
    // sync: performance.now() can stop while a phone sleeps or the app is
    // suspended, leaving timers behind until the next response re-syncs.
    return computed(() => new Date(clientNow.value.getTime() + serverOffsetMs.value));
}
